var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basic-loading"},[_c('img',{staticStyle:{"height":"50px"},attrs:{"src":require("../assets/loading.svg"),"alt":"","width":_vm.getLoadingIconSize}}),(_vm.tip)?_c('span',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.tip))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }